import { createContext, useContext, ReactNode } from 'react';
import { useToastQueue, UseToastQueue } from '#root/hooks/useToastQueue';

/**
 * Context para compartir el queue de toasts globalmente
 */
const ToastQueueContext = createContext<UseToastQueue | null>(null);

interface ToastQueueProviderProps {
  children: ReactNode;
}

/**
 * Provider que crea una única instancia del toast queue
 * y la comparte con todos los componentes hijos
 */
export const ToastQueueProvider = ({ children }: ToastQueueProviderProps) => {
  const queue = useToastQueue({
    maxToasts: 4, // Aumentado a 4 para testing (permite ver las 4 variantes simultáneamente)
    position: 'top-right',
  });

  return <ToastQueueContext.Provider value={queue}>{children}</ToastQueueContext.Provider>;
};

/**
 * Hook para acceder al queue global de toasts
 * Debe usarse dentro de un ToastQueueProvider
 */
export const useToastQueueContext = () => {
  const context = useContext(ToastQueueContext);

  if (!context) {
    throw new Error('useToastQueueContext must be used within ToastQueueProvider');
  }

  return context;
};
